import BaseProxy from "../../base-proxy";

/**
 * @class SubscriptionPaymentPostProxy
 * @description Class used for communicating with company subscription API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since December 18, 2018
 */
export default class SubscriptionPaymentPostProxy {
  /**
   * @async
   * @function execute
   * @param input Generic input parameter instance
   * @param data - Generic data parameter instance.
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} input.card_id - Credit Card Id.
   * @param {Array} input.companySubscriptionIds - Company subscription ids.
   */
  async execute(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let subscriptionIds = input.companySubscriptionIds
      .map((subscriptionId) => `companySubscriptionIds=${subscriptionId}`)
      .join("&");
    let endpointUrl = `${backendUrl}/payment/company-subscriptions?${subscriptionIds}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
